import { render, staticRenderFns } from "./DetailQuote.vue?vue&type=template&id=32bf7f64&lang=html&"
import script from "./DetailQuote.vue?vue&type=script&lang=js&"
export * from "./DetailQuote.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuote.vue?vue&type=style&index=0&id=32bf7f64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports